export default proofOfResModalCtrl

/** @ngInject */
function proofOfResModalCtrl($scope, $state, $uibModalInstance, User, contractId, $http, AlertManager) {
    $scope.close = $uibModalInstance.close
    $scope.people = null
    $scope.civs = []
    $scope.fns = []
    $scope.lns = []
    $scope.queryParams = ''
    $scope.contractId = contractId

    $scope.addPerson = function () {
        $scope.people = $scope.people || []

        if ($scope.people.length < 5) {
            return $scope.people.push({ fn: '', ln: '' })
        }
        return AlertManager.addAlert({ type: 'danger', msg: 'Vous ne pouvez pas ajouter plus de 5 personnes.' })
    }

    $scope.removePeople = (index) => $scope.people.splice(index, 1)

    return $scope.$watch(
    'people',
    (people) => {
        if (people && (people.length > 0)) {
            for (let i = 0, end = people.length, asc = end >= 0; asc ? i < end : i > end; asc ? i += 1 : i -= 1) {
                $scope.lns[i] = people[i].ln
                $scope.civs[i] = people[i].civ
                $scope.fns[i] = people[i].fn
            }

            const fnsString = `firstnames=${$scope.fns.join(',')}`
            const lnsString = `lastnames=${$scope.lns.join(',')}`
            const civsString = `civs=${$scope.civs.join(',')}`
            return $scope.$evalAsync(() => {
                $scope.queryParams = `?${fnsString}&${lnsString}&${civsString}`
            })
        }
    },
    true)
}



// WEBPACK FOOTER //
// ./src/states/proofOfResModal/proofofresmodal.js